import { takeEvery, all, takeLatest } from 'redux-saga/effects';
import * as actionTypes from '../actions/actionTypes';

import {
  logoutSaga,
  checkAuthTimeoutSaga,
  authUserSaga,
  authCheckStateSaga,
  checkPinxtTimeoutSaga,
  pinxtSaga,
  pinxtCheckStateSaga,
  authTokenSaga,
  startAppSaga,
} from './auth';
import {
  initEquipmentSaga,
  initSelectedEquipmentSaga,
  rebootPodSaga,
  claimPodSaga,
  reclaimPodSaga,
  changePodSaga,
  setLocatePodSaga,
  locateAllPodsSaga,
  changeEquipmentName,
} from './equipment';
import {
  initWanSaga,
  getOneWanSaga,
  addWanSaga,
  deleteWanSaga,
  editWanSaga,
  checkWanSaga,
  wanConnectedSaga,
  checkNetworkWifiServiceSaga,
  runWifiServiceCheckSaga,
} from './wan';
import {
  initConnectivitySaga,
  moveInSaga,
  moveOutSaga,
  initGetSpectrumReadyStatusSaga,
  reconcileTenantSuspensionOnTenantChangeSaga
} from './spectrumReady';
import {
  initManagedSaga,
  getOneManagedSaga,
  addManagedSaga,
  deleteManagedSaga,
  editManagedSaga
} from './managed';
import {
  initDevicesSaga,
  getOneDevicesSaga,
  addDevicesSaga,
  deleteDevicesSaga,
  changeDeviceNameSaga,
  changeDeviceIconSaga,
  changePauseDeviceSaga,
  changeFreezeDeviceSaga,
  deleteDeviceSaga,
  getAdvancedDeviceSaga,
  getAdvancedDeviceIdsSaga,
  reportAdidIssueSaga,
  deleteFreezesOnDeviceSaga,
} from './devices';
import {
  initDeviceGroupsSaga,
  changeDeviceGroupDetailsSaga,
  pauseDeviceGroupSaga,
  createDeviceGroupSaga,
  getDevicesFromGroupSaga,
  togglePauseDeviceGroupSaga,
  deleteGroups,
  unassignedDeviceGroups,
  freezeDeviceGroup,
  createPauseScheduleSaga,
  deleteGroupPauseScheduleSaga,
} from './devicegroups';
import {
  initDnsSaga,
  getOneDnsSaga,
  addDnsSaga,
  deleteDnsSaga,
  changeDnsSaga
} from './dns';
import {
  initDhcpSaga,
  getOneDhcpSaga,
  addDhcpSaga,
  deleteDhcpSaga,
  editDhcpSaga,
  addPortAssignmentSaga,
  deletePortAssignmentSaga,
  changePortAssignmentSaga,
  addIpReservationSaga,
  deleteIpReservationSaga,
  getDhcpReservationsSaga
} from './dhcp';
import {
  initUpnpSaga,
  getOneUpnpSaga,
  addUpnpSaga,
  deleteUpnpSaga,
  changeUpnpSaga,
} from './upnp';

import {
  initMobileHomeSaga,
  getOneMobileHomeSaga,
  addMobileHomeSaga,
  deleteMobileHomeSaga,
  changeMobileHomeSaga,
} from './mobileHome';
import {
  initTopologySaga,
  getOneTopologySaga,
  addTopologySaga,
  deleteTopologySaga,
  editTopologySaga
} from './topology';
import {
  initBandwidthSaga,
  getOneBandwidthSaga,
  addBandwidthSaga,
  deleteBandwidthSaga,
  editBandwidthSaga
} from './bandwidth';
import {
  initSettingsSaga,
  getOneSettingsSaga,
  addSettingsSaga,
  deleteSettingsSaga,
  editSettingsSaga,
  changeNamePassSaga,
  rebootRouterSaga,
  resetRouterSaga,
  optimizeRouterSaga,
  updateFirmwareSaga,
  runSpeedTestSaga,
  getSpeedTestSaga,
  getFirmwareUpdateSaga,
  checkFirmwareSaga,
  getWINVersion,
} from './settings';

import {
  initSpeedBoostLogsSaga,
  getSpeedBoostCheckDevicesSaga,
} from './speedBoost';

import {
  initLogsSaga,
  addLogSaga,
  deleteLogSaga,
  editLogSaga,
  getLogLinkSaga
} from './logs';
import {
  initUsersSaga,
  getOneUserSaga,
  addUserSaga,
  deleteUserSaga,
  editUserSaga
} from './users';

import {
  createMultipleAdvancedWifiSaga,
  getEntitlementSaga,
  getMultiRouterBySoloId,
  deleteMultipleAdvancedWifiSaga
} from './multipleAdvancedHomeWifi';

import {
  handleAdvancedSecuritySaga
} from './advancedSecurity';

import {
  getAdvancedSecurityThreatsSaga, initSecurityLogInfoSaga
} from './securityThreats';

import {
  getPropertyManagerSaga,
  getPropertyManagerTenantDetailsSaga,
  restoreServiceTenantAccountSaga,
  resumeSpecReadyServiceTenantAccountSaga
} from './propertyManager';

import {
  // checkRouterSpeedCheckVisibilitySaga,
  fetchRouterSpeedCheckResultsSaga,
  startRouterSpeedCheckSaga,
  checkRouterSpeedServiceSaga,
  logSpeedCheckSaga,
} from './routerSpeedCheck';

import {
  disableDeviceSteeringSaga,
  getDeviceSteeringSaga,
  startForcedSteeringSaga,
  startSmartSteeringAllSaga
} from './deviceSteering';

import {
  getHistoricalQoeMetricsSaga,
  getQoeScoresSaga,
  logQoeResultsSaga,
} from './qoe';

import {
  getMultiRouterSaga,
  assignPodsSaga,
  unClaimedPodsSaga
} from './multiRouter';

import {
  fetchPortForwardingSaga,setNewDHCPReservationsSaga
} from './portForwarding'
import { getSecondSsidSaga, addSecondSsidInfoDetailsSaga,deleteSecondSsidInfoDetailsSaga } from './2ndSSID';
import { getStaticIps } from '../actions';
import { deleteStaticIpInfoDetailsSaga, getStaticIpsSaga,setStaticIpSaga } from './staticIp';
import { createIOTssidNetworkSaga,
   deleteIOTssidNetoworkSaga,
   getIOTNetworkDevicesSaga,
   getIOTssidNetworkDetailsSaga,
   getallIOTssidNetworkDetailsSaga,
   getNetworksSaga,
   getNetworkDevicesSaga,
   updateNetworkSaga,
   deleteNetworkSaga,
   getGuestNetworkSessionSaga,
   updateGuestNetworkSessionSaga,
   getGuestNetworkScheduleSaga,
   updateGuestNetworkScheduleSaga,
   getNetworkDevicePauseStateSaga,
   pauseNetworkDeviceSaga,
   unpauseNetworkDeviceSaga } from './IOTNetwork';
import { updateWifiSecurityChangeAllSaga, setWifiSecurityBandSaga,getAllWifiSecuritySummarySaga } from './wifiSecurity';
import { getNetworkThreadSaga, toggleNetworkThreadSaga, getThreadRadioStatusSaga } from './networkThread';
import { initCellularSaga } from './cellularBackup';
import { initStaticIPConfigSaga } from './staticIPConfig';
import { initBroadcastSettingsSaga } from './broadcastSettings';


export function* watchAuth() {
  yield all([
    takeEvery(actionTypes.AUTH_CHECK_TIMEOUT, checkAuthTimeoutSaga),
    takeEvery(actionTypes.AUTH_INITIATE_LOGOUT, logoutSaga),
    takeEvery(actionTypes.AUTH_USER, authUserSaga),
    takeEvery(actionTypes.START_APP, startAppSaga),
    takeEvery(actionTypes.AUTH_TOKEN, authTokenSaga),
    takeEvery(actionTypes.AUTH_CHECK_STATE, authCheckStateSaga),
    takeEvery(actionTypes.PINXT_CHECK_TIMEOUT, checkPinxtTimeoutSaga),
    takeEvery(actionTypes.PINXT_TRY, pinxtSaga),
    takeEvery(actionTypes.PINXT_CHECK_STATE, pinxtCheckStateSaga),
  ]);
}

export function* watchEquipment() {
  yield takeEvery(actionTypes.INIT_SETTINGS, initEquipmentSaga);
  yield takeEvery(actionTypes.INIT_GET_ALL, initEquipmentSaga);
  yield takeEvery(actionTypes.INIT_SELECTED_EQUIPMENT, initSelectedEquipmentSaga);
  yield takeEvery(actionTypes.INIT_EQUIPMENT, initEquipmentSaga);
  yield takeEvery(actionTypes.REBOOT_POD, rebootPodSaga);
  yield takeEvery(actionTypes.CLAIM_POD, claimPodSaga);
  yield takeEvery(actionTypes.RECLAIM_POD, reclaimPodSaga);
  yield takeEvery(actionTypes.CHANGE_POD, changePodSaga);
  yield takeEvery(actionTypes.LOCATE_POD, setLocatePodSaga);
  yield takeEvery(actionTypes.LOCATE_ALL_PODS, locateAllPodsSaga);
  // yield takeEvery(actionTypes.REFRESH_DEVICES, locateAllPodsSaga);
  yield takeEvery(actionTypes.REFRESH_DEVICES, initEquipmentSaga);

}
export function* watchSettings() {
  yield takeEvery(actionTypes.INIT_CONNECTIVITY, initConnectivitySaga);
  yield takeEvery(actionTypes.INIT_SPECTRUM_STATUS, initGetSpectrumReadyStatusSaga);
  yield takeEvery(actionTypes.INIT_SETTINGS, initSettingsSaga);
  yield takeEvery(actionTypes.INIT_SETTINGS, getWINVersion);
  yield takeEvery(actionTypes.CHANGE_NAME_PASS, changeNamePassSaga);
  yield takeEvery(actionTypes.REBOOT_ROUTER, rebootRouterSaga);
  yield takeEvery(actionTypes.RESET_ROUTER, resetRouterSaga);
  yield takeEvery(actionTypes.OPTIMIZE_ROUTER, optimizeRouterSaga);
  yield takeEvery(actionTypes.UPDATE_FIRMWARE, updateFirmwareSaga);
  yield takeEvery(actionTypes.RUN_SPEED_TEST, runSpeedTestSaga);
  yield takeEvery(actionTypes.GET_SPEED_TEST, getSpeedTestSaga);
  yield takeEvery(actionTypes.GET_FIRMWARE_UPDATE, getFirmwareUpdateSaga);
  yield takeEvery(actionTypes.INIT_GET_ALL, initSettingsSaga);
  // yield takeEvery(actionTypes.INIT_GET_ALL, getFirmwareUpdateSaga);
  yield takeEvery(actionTypes.CHECK_FIRMWARE, checkFirmwareSaga);
}
export function* watchWan() {
  yield takeEvery(actionTypes.INIT_WAN, initWanSaga);
  yield takeEvery(actionTypes.INIT_GET_ALL, initWanSaga);
  yield takeEvery(actionTypes.CHECK_WAN, checkWanSaga);
  yield takeEvery(actionTypes.REFRESH_DEVICES, initWanSaga);
  yield takeEvery(actionTypes.RUN_WIFI_SERVICE_CHECK, runWifiServiceCheckSaga);
}

export function* watchSpecReady() {
  yield takeEvery(actionTypes.INIT_CONNECTIVITY, initConnectivitySaga);
  yield takeEvery(actionTypes.INIT_WAN, initConnectivitySaga);
  yield takeEvery(actionTypes.MOVE_IN, moveInSaga);
  yield takeEvery(actionTypes.MOVE_OUT, moveOutSaga);
  yield takeEvery(actionTypes.INIT_GET_ALL, initConnectivitySaga);
  // WIN-1702: re-assert router-level tenant suspension after bulk tenantData lands
  yield takeLatest(actionTypes.SET_TENANT, reconcileTenantSuspensionOnTenantChangeSaga);
}

export function* watchManaged() {
  yield takeEvery(actionTypes.INIT_MANAGED, initManagedSaga);
  yield takeEvery(actionTypes.INIT_GET_ALL, initManagedSaga);
}

export function* watchDevices() {
  yield takeEvery(actionTypes.INIT_DEVICES, initDevicesSaga);
  yield takeEvery(actionTypes.INIT_GET_ALL, initDevicesSaga);
  yield takeEvery(actionTypes.CHANGE_DEVICE_NAME, changeDeviceNameSaga);
  yield takeEvery(actionTypes.CHANGE_DEVICE_ICON, changeDeviceIconSaga);
  yield takeEvery(actionTypes.CHANGE_PAUSE_DEVICE, changePauseDeviceSaga);
  yield takeEvery(actionTypes.CHANGE_FREEZE_DEVICE, changeFreezeDeviceSaga);
  yield takeEvery(actionTypes.DELETE_DEVICE, deleteDeviceSaga);
  yield takeEvery(actionTypes.REFRESH_DEVICES, initDevicesSaga);
  yield takeEvery(actionTypes.REFRESH_DEVICES, initDhcpSaga);
  yield takeEvery(actionTypes.REFRESH_DEVICES, initDeviceGroupsSaga);
  yield takeEvery(actionTypes.REFRESH_DEVICES, getAdvancedDeviceIdsSaga);
  yield takeEvery(actionTypes.REFRESH_DEVICES, getSpeedBoostCheckDevicesSaga);
  yield takeEvery(actionTypes.GET_ADVANCED_DEVICE, getAdvancedDeviceSaga);
  yield takeEvery(actionTypes.GET_ADVANCED_DEVICE_IDS, getAdvancedDeviceIdsSaga);
  yield takeEvery(actionTypes.REPORT_ADID_ISSUE, reportAdidIssueSaga);
  yield takeEvery(actionTypes.DELETE_DEVICE_FREEZES, deleteFreezesOnDeviceSaga);
}

export function* watchDeviceGroups() {
  yield takeEvery(actionTypes.INIT_DEVICE_GROUPS, initDeviceGroupsSaga);
  yield takeEvery(actionTypes.CREATE_DEVICE_GROUP, createDeviceGroupSaga);
  yield takeEvery(actionTypes.CREATE_GROUP_PAUSE_SCHEDULE, createPauseScheduleSaga);
  yield takeEvery(actionTypes.DELETE_GROUP_PAUSE_SCHEDULE, deleteGroupPauseScheduleSaga)
  yield takeEvery(actionTypes.GET_DEVICES_FROM_GROUP, getDevicesFromGroupSaga);
  yield takeLatest(actionTypes.DELETE_GROUPS, deleteGroups);
  yield takeEvery(actionTypes.CHANGE_DEVICE_GROUP_DETAILS, changeDeviceGroupDetailsSaga);
  yield takeEvery(actionTypes.PAUSE_DEVICE_GROUP, pauseDeviceGroupSaga);
  yield takeLatest(actionTypes.UNASSIGN_DEVICE_GROUPS, unassignedDeviceGroups);
  yield takeLatest(actionTypes.FREEZE_DEVICE_GROUP, freezeDeviceGroup);
}

export function* watchDhcp() {
  yield takeEvery(actionTypes.INIT_DHCP, initDhcpSaga);
  yield takeEvery(actionTypes.INIT_GET_ALL, initDhcpSaga);
  yield takeEvery(actionTypes.CHANGE_DNS, changeDnsSaga);
  yield takeEvery(actionTypes.ADD_PORT_ASSIGNMENT, addPortAssignmentSaga);
  yield takeEvery(actionTypes.DELETE_PORT_ASSIGNMENT, deletePortAssignmentSaga);
  yield takeEvery(actionTypes.CHANGE_PORT_ASSIGNMENT, changePortAssignmentSaga);
  yield takeEvery(actionTypes.ADD_IP_RESERVATION, addIpReservationSaga);
  yield takeEvery(actionTypes.DELETE_IP_RESERVATION, deleteIpReservationSaga);
  yield takeEvery(actionTypes.GET_DHCP_RESERVATIONS,getDhcpReservationsSaga);
}

export function* watchDns() {
  yield takeEvery(actionTypes.INIT_DNS, initDnsSaga);
  yield takeEvery(actionTypes.INIT_GET_ALL, initDnsSaga);
}

export function* watchUpnp() {
  yield takeEvery(actionTypes.INIT_UPNP, initUpnpSaga);
  yield takeEvery(actionTypes.INIT_GET_ALL, initUpnpSaga);
  yield takeEvery(actionTypes.CHANGE_UPNP, changeUpnpSaga);

}
export function* watchMobileHome() {
  yield takeEvery(actionTypes.INIT_MOBILE_HOME, initMobileHomeSaga);
  yield takeEvery(actionTypes.INIT_GET_ALL, initMobileHomeSaga);
  yield takeEvery(actionTypes.CHANGE_MOBILE_HOME, changeMobileHomeSaga);
}

export function* watchTopology() {
  yield takeEvery(actionTypes.INIT_TOPOLOGY, initTopologySaga);
}
export function* watchBandwidth() {
  yield takeEvery(actionTypes.INIT_BANDWIDTH, initBandwidthSaga);
  yield takeEvery(actionTypes.INIT_GET_ALL, initBandwidthSaga);
  yield takeEvery(actionTypes.REFRESH_DEVICES, initBandwidthSaga);
}
export function* watchLogs() {
  yield takeLatest(actionTypes.EDIT_LOGS, editLogSaga);
  yield takeLatest(actionTypes.DELETE_LOGS, deleteLogSaga);
  yield takeLatest(actionTypes.ADD_LOGS, addLogSaga);
  yield takeEvery(actionTypes.INIT_LOGS, initLogsSaga);
  yield takeEvery(actionTypes.GET_LOG_LINK, getLogLinkSaga);
}
export function* watchSpeedBoostLogs() {
  yield takeEvery(actionTypes.INIT_SB_LOGS, initSpeedBoostLogsSaga);
  yield takeEvery(actionTypes.DEVICES_GET_SPEED_BOOST, getSpeedBoostCheckDevicesSaga);

  yield takeEvery(actionTypes.REFRESH_DEVICES, () => {
    let featureFlags = sessionStorage.getItem('featureFlags');

    if (featureFlags.includes('speedBoost')) {
      return getSpeedBoostCheckDevicesSaga
    } else {
      // console.log('NO RETURN', featureFlags)
      return
    }
  });
}
export function* watchUsers() {
  yield takeLatest(actionTypes.EDIT_USERS, editUserSaga);
  yield takeLatest(actionTypes.DELETE_USERS, deleteUserSaga);
  yield takeLatest(actionTypes.ADD_USERS, addUserSaga);
  yield takeEvery(actionTypes.INIT_USERS, initUsersSaga);
  yield takeEvery(actionTypes.GET_ONE_USER, getOneUserSaga);
}


export function* watchMultipleAdvancedHomeWifi() {
  // yield takeEvery(actionTypes.INIT_MULTIADVANCEDWIFI, initMultipleAdvancedWifSaga);
  yield takeEvery(actionTypes.CREATE_MULTIADVANCEDWIFI, createMultipleAdvancedWifiSaga);
  yield takeEvery(actionTypes.GET_ENTITLEMENT, getEntitlementSaga);
  yield takeEvery(actionTypes.GET_MULTIROUTER_BY_SOLOID, getMultiRouterBySoloId);
  yield takeEvery(actionTypes.DELETE_MULTIADVANCEDWIFI, deleteMultipleAdvancedWifiSaga)

}

export function* watchAdvancedSecurity() {
  yield takeEvery(actionTypes.ADVANCED_SECURITY_HANDLER, handleAdvancedSecuritySaga);
}

export function* watchSecurityThreats() {
  yield takeEvery(actionTypes.GET_ADVANCED_SECURITY_THREATS, getAdvancedSecurityThreatsSaga);
  yield takeEvery(actionTypes.INIT_SECURITY_LOG_INFO, initSecurityLogInfoSaga);

}

export function* watchPropertyManager() {
  yield takeEvery(actionTypes.GET_PROPERTY_MANAGER_DETAILS, getPropertyManagerSaga);
  yield takeEvery(actionTypes.GET_PROPERTY_MANAGER_TENANT_DETAILS, getPropertyManagerTenantDetailsSaga);
  yield takeEvery(actionTypes.RESTORE_SERVICE_TENANT_ACCOUNT, restoreServiceTenantAccountSaga);
  yield takeEvery(actionTypes.RESUME_SPEC_READY_SERVICE_TENANT_ACCOUNT, resumeSpecReadyServiceTenantAccountSaga);
}

export function* watchRouterSpeedCheck() {
  // yield takeEvery(actionTypes.GET_RSC_IS_AVAILABLE, checkRouterSpeedCheckVisibilitySaga);
  yield takeEvery(actionTypes.GET_RSC_START_TIME, startRouterSpeedCheckSaga);
  yield takeEvery(actionTypes.GET_RSC_RESULTS, fetchRouterSpeedCheckResultsSaga);
  yield takeEvery(actionTypes.LOG_SPEED_TEST, logSpeedCheckSaga);
}

export function* watchDeviceSteering() {
  yield takeEvery(actionTypes.STOP_DEVICE_STEERING, disableDeviceSteeringSaga);
  yield takeEvery(actionTypes.GET_DEVICE_STEERING, getDeviceSteeringSaga)
  yield takeEvery(actionTypes.START_DEVICE_STEERING_POLLING, startForcedSteeringSaga);
  yield takeEvery(actionTypes.START_DEVICE_STERING_ALL_POLLING, startSmartSteeringAllSaga);
}

export function* watchQoe() {
  yield takeEvery(actionTypes.GET_HISTORICAL_QOE_METRICS, getHistoricalQoeMetricsSaga);
  yield takeEvery(actionTypes.GET_QOE_SCORES, getQoeScoresSaga);
  yield takeEvery(actionTypes.LOG_QOE_RESULTS, logQoeResultsSaga)
}

export function* watchMultiRouter() {
  yield takeEvery(actionTypes.GET_MULTI_ROUTER, getMultiRouterSaga);
  yield takeEvery(actionTypes.ASSIGN_POD, assignPodsSaga)
  yield takeEvery(actionTypes.UNCLAIMED_POD, unClaimedPodsSaga);
}

export function* watchPortForwarding() {
  yield takeEvery(actionTypes.FETCH_PORT_FORWARDING, fetchPortForwardingSaga)
  yield takeEvery(actionTypes.SET_NEW_DHCP_RESERVATIONS, setNewDHCPReservationsSaga)
}

export function* watchSecondSsid() {
  yield takeEvery(actionTypes.GET_SECOND_SSID, getSecondSsidSaga)
  yield takeEvery(actionTypes.ADD_SECOND_SSID_INFO, addSecondSsidInfoDetailsSaga)
  yield takeEvery(actionTypes.DELETE_SECOND_SSID_INFO, deleteSecondSsidInfoDetailsSaga)
}

export function* watchStaticIp() {
  yield takeEvery(actionTypes.GET_STATIC_IP, getStaticIpsSaga)
  yield takeEvery(actionTypes.SET_STATIC_IP, setStaticIpSaga)
  yield takeEvery(actionTypes.DELETE_STATIC_IP_INFO,deleteStaticIpInfoDetailsSaga)
}


export function* watchPropertyIOTNetwork() {
  yield takeEvery(actionTypes.CREATE_IOT_SSID_NETWORK,createIOTssidNetworkSaga);
  yield takeEvery(actionTypes.GET_IOT_SSID_NETWORK_DETAILS,getIOTssidNetworkDetailsSaga);
  yield takeEvery(actionTypes.GET_ALL_IOT_SSID_NETWORK_DETAILS, getallIOTssidNetworkDetailsSaga);
  yield takeEvery(actionTypes.GET_IOT_NETWORK_DEVICES, getIOTNetworkDevicesSaga);
  yield takeEvery(actionTypes.GET_NETWORKS, getNetworksSaga);
  yield takeEvery(actionTypes.GET_NETWORK_DEVICES, getNetworkDevicesSaga);
  yield takeEvery(actionTypes.UPDATE_NETWORK, updateNetworkSaga);
  yield takeEvery(actionTypes.DELETE_NETWORK, deleteNetworkSaga);
  yield takeEvery(actionTypes.GET_GUEST_NETWORK_SESSION, getGuestNetworkSessionSaga);
  yield takeEvery(actionTypes.UPDATE_GUEST_NETWORK_SESSION, updateGuestNetworkSessionSaga);
  yield takeEvery(actionTypes.GET_GUEST_NETWORK_SCHEDULE, getGuestNetworkScheduleSaga);
  yield takeEvery(actionTypes.UPDATE_GUEST_NETWORK_SCHEDULE, updateGuestNetworkScheduleSaga);
  yield takeEvery(actionTypes.GET_NETWORK_DEVICE_PAUSE_STATE, getNetworkDevicePauseStateSaga);
  yield takeEvery(actionTypes.PAUSE_NETWORK_DEVICE, pauseNetworkDeviceSaga);
  yield takeEvery(actionTypes.UNPAUSE_NETWORK_DEVICE, unpauseNetworkDeviceSaga);
}

export function* watchWifiSecurity() {
  yield takeLatest(actionTypes.WIFI_SECURITY_CHANGE_ALL, updateWifiSecurityChangeAllSaga);
  yield takeLatest(actionTypes.SET_WIFI_SECURITY_BAND, setWifiSecurityBandSaga);
  // yield takeEvery(actionTypes.GET_ALL_WIFI_SECURITY_SUMMARY,getAllWifiSecuritySummarySaga )
}

export function* watchNetworkThread() {
  yield takeEvery(actionTypes.GET_NETWORK_THREAD, getNetworkThreadSaga)
  yield takeEvery(actionTypes.GET_THREAD_RADIO_STATUS, getThreadRadioStatusSaga)
  yield takeEvery(actionTypes.TOGGLE_NETWORK_THREAD, toggleNetworkThreadSaga)
}

export function* watchCellularBackup() {
  yield takeEvery(actionTypes.INIT_CELLULAR, initCellularSaga)
}

export function* watchStaticIPConfig() {
  yield takeEvery(actionTypes.INIT_STATIC_IP_CONFIG, initStaticIPConfigSaga);
  yield takeEvery(actionTypes.INIT_GET_ALL, initStaticIPConfigSaga);
}

export function* watchBroadcastSettings() {
  yield takeEvery(actionTypes.INIT_BROADCAST_SETTINGS, initBroadcastSettingsSaga);
  yield takeEvery(actionTypes.INIT_GET_ALL, initBroadcastSettingsSaga);
}
